import { render, staticRenderFns } from "./BreadcrumbsApp.vue?vue&type=template&id=2c729bf0&scoped=true&"
import script from "./BreadcrumbsApp.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c729bf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
